<template>
  <div>

    <h5> Как сделать скриншот на Android?</h5>
    <ul>
      <li>Одновременно нажмите и удерживайте кнопку питания и кнопку уменьшения громкости примерно 1- 2 секунды.
        Скриншот будет сохранен в галере</li>
      <li>Зайдите на любой хостинг картинок например <a href="https://ru.imgbb.com/"
          target="blank">https://ru.imgbb.com/</a> и загрузите ваш скриншот. </li>

      <li>Скоприруйие полученую ссылку и укажите ее в отчете</li>

    </ul>

    <h5> Как сделать скриншот на iPhone?</h5>
    <ul>
      <li>Нажмите и удерживайте боковую кнопку, далее нажмите клавишу увеличения
        громкости. Скриншот будет сохранен в галере</li>
      <li>Зайдите на любой хостинг картинок например <a href="https://ru.imgbb.com/"
          target="blank">https://ru.imgbb.com/</a> и загрузите ваш скриншот. </li>
      <li>Скоприруйие полученую ссылку и укажите ее в отчете</li>
    </ul>

    <h5> Как сделать скриншот в Windows?</h5>

    <ol>
      <li>Нажмите кнопку Print Screen (PrntScrn). Обычно кнопка распологается вверху после кнопки F12</li>

      <li> Откройте программу Paint ( Ее можно найти в меню пуск ) и нажмите Ctrl + V. В программе должен появится ваш
        скриншот</li>

      <li>Выберите в меню сверху слева 'Файл' далее 'Сохранить как', и сохраните файл в любое место</li>

      <li>Зайдите на любой хостинг картинок например <a href="https://ru.imgbb.com/"
          target="blank">https://ru.imgbb.com/</a> и загрузите ваш скриншот. </li>

      <li>Скоприруйие полученую ссылку и укажите ее в отчете</li>
      <li> Вы так же можете сделать скриншот в любой дрйгой программе для скришотов например clip2net.com</li>
    </ol>

    <h5> Как сделать скриншот в MacOs?</h5>

    <ol>
      <li>Зажмите кнопку command далее левый shift и далее кнопку 4. Курсор поменятеся, выделите нужную часть экрана.
        После выделения скришот будет сохранен на вашем рабочем столе. </li>

      <li>Зайдите на любой хостинг картинок например <a href="https://ru.imgbb.com/"
          target="blank">https://ru.imgbb.com/</a> и загрузите ваш скриншот. </li>

      <li>Скоприруйие полученую ссылку и укажите ее в отчете</li>
      <li> Вы так же можете сделать скриншот в любой дрйгой программе для скришотов например clip2net.com</li>
    </ol>


  </div>
</template>
<script>

export default {



}
</script>





